import { render, staticRenderFns } from "./DocumentPromulgate.vue?vue&type=template&id=1ce1bb02&scoped=true"
import script from "./DocumentPromulgate.vue?vue&type=script&lang=js"
export * from "./DocumentPromulgate.vue?vue&type=script&lang=js"
import style0 from "./DocumentPromulgate.vue?vue&type=style&index=0&id=1ce1bb02&prod&lang=scss&scoped=true"
import style1 from "./DocumentPromulgate.vue?vue&type=style&index=1&id=1ce1bb02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1bb02",
  null
  
)

export default component.exports